/* eslint-disable */
"use strict";

var cacheLoader = require('../cacheLoader');
var MAX_RETRIES = 4;
var RETRY_DELAY = 500;

module.exports = cacheLoader(function (bundle) {
  return new Promise(function (resolve, reject) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    var existingScripts = document.getElementsByTagName('script');
    if ([].concat(existingScripts).some(function (script) {
      return script.src === bundle;
    })) {
      resolve();
      return;
    }
    var preloadLink = document.createElement('link');
    preloadLink.href = bundle;
    preloadLink.rel = 'preload';
    preloadLink.as = 'script';
    document.head.appendChild(preloadLink);

    function attempt(remainingRetries) {
      var script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = bundle;
      script.onerror = function (e) {
        script.onerror = script.onload = null;
        script.remove();
        if (remainingRetries > 0) {
          setTimeout(() => attempt(remainingRetries - 1), RETRY_DELAY);
        } else {
          var error = new TypeError("Failed to fetch dynamically imported module after 3 retries: ".concat(bundle, ". Error: ").concat(e.message));
          reject(error);
        }
      };
      script.onload = function () {
        script.onerror = script.onload = null;
        resolve();
      };

      document.getElementsByTagName('head')[0].appendChild(script);
    };

    attempt(MAX_RETRIES);
  });
});